import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {
  "pageTitle": "Time Picker Design Guidelines",
  "title": "Time Picker",
  "order": 1
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const LeadParagraph = makeShortcode("LeadParagraph");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <PageContent componentName="time_picker" type="design" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">Capture time from the user</LeadParagraph>
      <h2>{`Usage`}</h2>
      <p>{`The Time input gives the user the ability to input a time in a format the developer can control.`}</p>
      <figure>{`
  `}<div parentName="figure" {...{
          "className": "image-container"
        }}>{`
    `}<span parentName="div" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "756px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "69.88416988416989%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAIAAACgpqunAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAdUlEQVQoz93QywoDIQyFYd//GV0rwQsuTDQxHQeybAsdaEuh3/7nwHH7De7D8WF+sTzGQMQr40/iUkoIQURU9WbUXIpbawDQTa0150xEzPzYu7ur9t4xRu997x0RU0oAQESqKiKvl8WwEZG11pyTmb//9t/HJ090QHX1YNhIAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "",
              "title": "",
              "src": "/static/38b1f4bbc491649df05c5f9479f259ac/8ae3e/time-input-example.png",
              "srcSet": ["/static/38b1f4bbc491649df05c5f9479f259ac/a2ead/time-input-example.png 259w", "/static/38b1f4bbc491649df05c5f9479f259ac/6b9fd/time-input-example.png 518w", "/static/38b1f4bbc491649df05c5f9479f259ac/8ae3e/time-input-example.png 756w"],
              "sizes": "(max-width: 756px) 100vw, 756px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>{`
  `}</div>
      </figure>
      <h2>{`Keyboard controls`}</h2>
      <p>{`You can tab into the Time input to individually manipulate the hours, minutes, and AM/PM indicator. Use the up and down arrows to change their values.`}</p>
      <figure>{`
  `}<div parentName="figure" {...{
          "className": "image-container"
        }}>{`
    `}<span parentName="div" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "600px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "49.42084942084942%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABA0lEQVQoz5WS2U7DMBBF++vwgsoD4sfKltjJI2TBZLy0UlSQm9oXxbTghKQUSyN7Rp6rc+1ZAID3PkR8Hud/rOMFvxhUR42x6L8EQ8OhyVqLrusOZEPiufiS8BFhZEsriSzLQNQcMWPkCGbgZIIQwN55JJVBWmkkpQKrDVilwSoVIhPrUHsqJB5fKNz9eRX/W1BvLfKSkHMGKSWUlGjbFhdXKyxv7kEkoLX+JksKiXfbzQuarQUrGnDO8fpGEA1Brze4vF5heXsH0QiQMtjtHZzzeHgmfOxOCPaW08oEa7w2USjwWiMXm5CnpQp0vf1Jy2eOxvzMzH1Kv7uJsXAn6uOx+QTYBQlzquF+uQAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "",
              "title": "",
              "src": "/static/585de8496e37e25008a64dbc454f054c/0a47e/time-input-keyboard.png",
              "srcSet": ["/static/585de8496e37e25008a64dbc454f054c/a2ead/time-input-keyboard.png 259w", "/static/585de8496e37e25008a64dbc454f054c/6b9fd/time-input-keyboard.png 518w", "/static/585de8496e37e25008a64dbc454f054c/0a47e/time-input-keyboard.png 600w"],
              "sizes": "(max-width: 600px) 100vw, 600px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>{`
  `}</div>
      </figure>
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      